import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { HTML_LINK_TARGET } from '../../../constants/html'
import { useLinkLikeClick } from '../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { EntityProfileHeaderTitleActionsSelect } from '../../Entity'
import { ICON_HEIGHT_24 } from '../../Icon'
import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../MultipleViewTypeListActiveItemPreviewCloseButton'

import { getOpenLinkTooltip } from './MultipleViewTypeListActiveItemPreviewHeaderActions.utils'

import OpenInNewWindowIcon from '../../../icons/open-in-new-window.svg'

function MultipleViewTypeListActiveItemPreviewHeaderActions({
  Actions = EntityProfileHeaderTitleActionsSelect,
  closeButtonProps,
  getProfileLink,
  id,
  isLoading,
  openInNewTabButtonProps,
  openLinkTarget = HTML_LINK_TARGET.blank,
  onClosePreview,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  function handleOpenLink(event) {
    handleClick({
      event,
      link: getProfileLink({ id }),
      target: openLinkTarget,
    })
  }

  function handleMouseDownOpenLink(event) {
    handleMouseDown({
      event,
      link: getProfileLink({ id }),
    })
  }

  return (
    <>
      {isLoading ? null : (
        <Button.Flat
          {...openInNewTabButtonProps}
          isGrey
          beforeIconProps={{
            Icon: OpenInNewWindowIcon,
            height: ICON_HEIGHT_24,
          }}
          height={BUTTON_HEIGHT_32}
          tooltip={getOpenLinkTooltip({
            openInNewTabButtonProps,
            openLinkTarget,
            t,
          })}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={handleOpenLink}
          onMouseDown={handleMouseDownOpenLink}
        />
      )}
      {Actions ? <Actions {...restProps} isLoading={isLoading} /> : null}
      {onClosePreview ? (
        <MultipleViewTypeListActiveItemPreviewCloseButton
          {...closeButtonProps}
          onClose={onClosePreview}
        />
      ) : null}
    </>
  )
}

export default MultipleViewTypeListActiveItemPreviewHeaderActions
